<div class="form-field" [formGroup]="parent" [ngClass]="{'has-error': parent.get(controllerData.controlName).touched
&& parent.get(controllerData.controlName).errors}" role="phoneNumber" [attr.aria-describedby]="controllerData['name']">
  <label [id]="controllerData['name']" [attr.for]="pageName+'-'+controllerData['name']" class="form-label">{{controllerData['label']}}</label>
  
  <input [formControlName]="controllerData['controlName']" 
        [name]="controllerData['name']" type="text" 
        [id]="pageName+'-'+controllerData['name']"
        [(ngModel)]="controllerData.value" aria-invalid="false" 
        [placeholder]="controllerData['placeHolder']"
        class="form-control modalClose-focus"
        [value]="controllerData['value']"
        [required]="controllerData['required']"
        (keyup.enter)="validateInput()"
        (blur)="validateInput()"
        [maxlength]="controllerData['maxlength']"
        inputmode="numeric"
        />
      

        <div [id]="controlName +'-error'"  class="form-validation-error"
                *ngIf="parent.get(controlName).touched
                        &&
                    parent.get(controlName).errors ">
                       
                   
                    <i class="icon icon-error" aria-hidden="true"></i>
             <p *ngIf="parent.get(controlName).touched
                         &&
                      parent.get(controlName).hasError('notValidPhone')" [id]="controlName +'-invalid-error'">
                      {{controllerData['invalidErrorMessage']}}
            </p>
            <p *ngIf="parent.get(controlName).touched
                         &&
                      parent.get(controlName).hasError('required')" [id]="controlName +'-invalid-error'">
                      {{controllerData['errorMessage']}}
            </p>
            <p *ngIf="parent.get(controlName).touched
            &&
         !parent.get(controlName).hasError('notValidname')
         &&
         parent.get(controlName).errors.pattern">{{controllerData['invalidErrorMessage']}}</p>
        </div> 
       

</div>